module.exports = __webpack_public_path__ + "img/med-over-net.1e9849f5.svg";